<template>
    <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <button type="button" class="btn btn-sm btn-outline-danger" @click="cerrar"><i
                    class="fas fa-times"></i></button>
        </div>
        <div class="contenedor_modal_completo_contenido">
            <b-container>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Movimientos
                        </h3>
                        <div class="datos_extras">
                            {{ objeto_busqueda.nombre }} SKU: {{ objeto_busqueda.codigo }} <br>
                            Sucursal: {{ objeto_busqueda.nombre_sucursal }}
                        </div>
                    </div>
                    <div class="col-sm-5 mt-3">
                        <label for="" class="form-label">Fecha Inicial</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
                    </div>
                    <div class="col-sm-5 mt-3">
                        <label for="" class="form-label">Fecha Final</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_final">
                    </div>
                    <div class="col-sm-2 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="obtener_resultados">Buscar</button>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <div class="marco_movimientos_producto">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                                <thead>
                                    <th style="width: 10%;text-align: center;">
                                        Fecha
                                    </th>
                                    <th style="width: 30%;">
                                        Información
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        T.Movimiento
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        T.Transaccion
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        S.Anterior
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        Entradas
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        Salidas
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        Saldo Actual
                                    </th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in resultados" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.fecha_movimiento }}
                                        </td>
                                        <td>
                                            {{ item.info_movimiento }}
                                        </td>
                                        <td v-if="item.tipo_de_movimiento == 'ENTRADA'"
                                            style="text-align: center;background-color:#517bc5;color: white;">
                                            {{ item.tipo_de_movimiento }}
                                        </td>
                                        <td v-else style="text-align: center;background-color:#529f50;color: white;">
                                            {{ item.tipo_de_movimiento }}
                                        </td>
                                        <td v-if="item.tipo_de_movimiento == 'ENTRADA'" style="text-align: center;">
                                            {{ item.transaccion == 'OTRAS_ENTRADAS' ? 'OTRAS ENTRADAS' :
                                                item.transaccion
                                            }}
                                        </td>
                                        <td v-else style="text-align: center;">
                                            {{ item.transaccion == 'OTRAS_SALIDAS' ? 'OTRAS SALIDAS' :
                                                item.transaccion
                                            }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.saldo_anterior }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.saldo_entradas }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.saldo_salidas }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.saldo_actual }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'ModalMovimientos',
        computed: {
            ...mapState(['datos_usuario', 'objeto_busqueda', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                resultados: [],
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_resultados() {
                let f = {
                    api: `movimientos-cabeceras/q/movimientos_por_producto?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&articulo=${this.objeto_busqueda.codigo}&sucursal=${this.objeto_busqueda.sucursal}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                this.resultados = r
            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style>
    .marco_movimientos_producto {
        width: 100%;
        height: calc(100vh - 280px);
        overflow: auto;
    }

    .datos_extras {
        line-height: 17px;
        font-weight: bold;
        font-size: 14px;
        color: #393033;
    }

</style>